"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VestingClaimInfoPopover = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const VestingClaimInfoPopover = () => {
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? "claim-info" : undefined;
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { zIndex: 1000 }, children: [(0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "icon", "aria-describedby": id, onClick: handleClick, children: (0, jsx_runtime_1.jsx)(icons_material_1.Help, {}) }), (0, jsx_runtime_1.jsx)(material_1.Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: "top",
                    horizontal: "left",
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "right",
                }, children: (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { p: 2, overflowX: "scroll" }, children: [(0, jsx_runtime_1.jsx)(ui_kit_1.Typography, { children: "Format: " }), (0, jsx_runtime_1.jsx)("pre", { children: "owner,startTimestamp,cliffInMonth,monthlyRelease,tokenType,address,templateId,amount" }), (0, jsx_runtime_1.jsx)(ui_kit_1.Typography, { children: "Example: " }), (0, jsx_runtime_1.jsx)("pre", { children: "0xfe3b557e8fb62b89f4916b721be55ceb828dbd73,2020-01-01T00:00:00.000Z,12,1000,ERC20,0x0000000000000000000000000000000000C0FFEE,0,1000000000000000000" })] }) })] }));
};
exports.VestingClaimInfoPopover = VestingClaimInfoPopover;
//# sourceMappingURL=popover.js.map